// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"245":"8110c76550872c302ab3","453":"3d4452b9974dbd859615","522":"828b959c392f1a411b61"}[chunkId] + ".js";
};